import { supabase } from '../supabaseClient'

class ActivityService {
  createActivity = async (payload: any): Promise<any> => {
    const { data: activity, error } = await supabase.from('activities').insert(payload)
    if (error) throw error
    return activity
  }

  updateActivity = async (id: number, payload: any): Promise<any> => {
    const { data, error } = await supabase.from('activities').update(payload).eq('id', id)
    if (error) throw error
    return data
  }

  deleteActivity = async (id: number, deletedBy: string): Promise<any> => {
    try {
      const { data, error } = await supabase
        .from('activities')
        .update({
          deleted: true,
          deleted_on: new Date().toISOString(),
          deleted_by: deletedBy,
        })
        .eq('id', id)

      if (error) {
        console.error(error)
        throw error
      }
      return data
    } catch (error) {
      console.error({ error })
      throw error
    }
  }
}

const activityService = new ActivityService()
export default activityService
